module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headings":{"links":"Links","content":"Other content","application":"Application"},"actions":{"logout":"Log out"}},"fi":{"headings":{"links":"Linkit","content":"Muu sisältö","application":"Sovellus"},"actions":{"logout":"Kirjaudu ulos"}}}')
  delete Component.options._Ctor
}
